$(function(){
	if ($("section.fondoFijoBack").length > 0){
		var backgroundFijo= $("section.fondoFijoBack").data("background");
		$("section.fondoFijoBack").css("background-image", "url("+backgroundFijo+")");
	}
})